// extracted by mini-css-extract-plugin
module.exports = {"submenuItem":"Menu_submenuItem__tPtib","menu":"Menu_menu__U13ZB"};